/**
 * Результат запрошення (ч.1073): чи пішов лист / повідомлення в Telegram +
 * посилання для копіювання як запасний шлях (месенджер, якщо лист не
 * дійшов). Спільне для «Запросити» і «надіслати ще раз».
 */
import { useState } from 'react';
import type { InvitationCreated } from '@/api/invitations';

export default function InvitationResult({ created }: { created: InvitationCreated }) {
  const [copied, setCopied] = useState(false);
  async function copy(url: string) {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('Скопіюйте посилання:', url);
    }
  }
  const channels = [created.email_sent && 'листом', created.telegram_sent && 'у Telegram']
    .filter(Boolean).join(' і ');
  return (
    <div>
      <div style={{
        background: channels ? 'var(--success-soft)' : 'var(--badge-amber-bg)',
        color: channels ? 'var(--success)' : 'var(--badge-amber-fg)',
        padding: '0.6rem 0.8rem', borderRadius: 'var(--radius-sm)',
        marginBottom: '1rem', fontSize: '0.875rem',
      }}>
        {channels
          ? `✓ Запрошення надіслано ${channels} на ${created.email}`
          : `Запрошення для ${created.email} створено, але лист не надіслано — передайте посилання самостійно.`}
      </div>
      {created.invitation_url && (
        <>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
            {channels
              ? 'Посилання (діє 7 днів) можна передати й самостійно, наприклад у месенджері:'
              : 'Посилання (діє 7 днів):'}
          </p>
          <div style={{
            background: 'var(--bg-soft)', padding: '0.6rem',
            borderRadius: 'var(--radius-sm)', fontFamily: 'monospace',
            fontSize: '0.75rem', wordBreak: 'break-all', marginBottom: '0.5rem',
          }}>
            {created.invitation_url}
          </div>
          <button type="button" onClick={() => copy(created.invitation_url!)}>
            {copied ? 'скопійовано' : 'скопіювати посилання'}
          </button>
        </>
      )}
    </div>
  );
}
